import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { IListingsUrls } from '../types/listingsUrls';

export const mapListingsUrls = (promosResponse: ISearchPromosV2ResponseSchema): IListingsUrls => {
  return {
    mapUrl: promosResponse.newbuildingsListingMapUrl || null,
    listingUrl: promosResponse.newbuildingsListingUrl || null,
  };
};
